import React from 'react';
import './MatchDetailModal.css';

export default function MatchDetailModal({ match, onClose }) {
  const getStatusColor = (status) => {
    switch (status) {
      case 'live':
        return '#e74c3c';
      case 'completed':
        return '#27ae60';
      case 'scheduled':
        return '#f39c12';
      default:
        return '#95a5a6';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'live':
        return '🔴 LIVE';
      case 'completed':
        return '✅ Completed';
      case 'scheduled':
        return '📅 Scheduled';
      default:
        return status;
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="match-detail-overlay" onClick={onClose}>
      <div className="match-detail-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="detail-header">
          <h2>{match.tournament}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {/* Status & Date */}
        <div className="detail-status">
          <span
            className="status-badge-large"
            style={{ backgroundColor: getStatusColor(match.status) }}
          >
            {getStatusIcon(match.status)}
          </span>
          <span className="detail-date">{formatDateTime(match.matchDate)}</span>
        </div>

        {/* Match Info */}
        <div className="detail-body">
          {/* Player 1 */}
          <div className="player-detail">
            <div className="player-info">
              <h3>{match.player1?.name || 'Player 1'}</h3>
              {match.player1?.ranking && (
                <p className="ranking">World Ranking: #{match.player1.ranking}</p>
              )}
              {match.player1?.team && (
                <p className="team">{match.player1.team}</p>
              )}
            </div>
          </div>

          {/* Score */}
          <div className="match-score-large">
            <div className="score-value">{match.score || 'vs'}</div>
            {match.stats?.duration && (
              <div className="score-duration">{match.stats.duration}</div>
            )}
          </div>

          {/* Player 2 */}
          <div className="player-detail">
            <div className="player-info">
              <h3>{match.player2?.name || 'Player 2'}</h3>
              {match.player2?.ranking && (
                <p className="ranking">World Ranking: #{match.player2.ranking}</p>
              )}
              {match.player2?.team && (
                <p className="team">{match.player2.team}</p>
              )}
            </div>
          </div>
        </div>

        {/* Details Section */}
        <div className="detail-info">
          {match.circuit && (
            <div className="info-row">
              <span className="info-label">Circuit:</span>
              <span className="info-value">{match.circuit}</span>
            </div>
          )}

          {match.location && (
            <div className="info-row">
              <span className="info-label">Location:</span>
              <span className="info-value">{match.location}</span>
            </div>
          )}

          {match.court && (
            <div className="info-row">
              <span className="info-label">Court:</span>
              <span className="info-value">{match.court}</span>
            </div>
          )}

          {match.stats?.winner && (
            <div className="info-row">
              <span className="info-label">Winner:</span>
              <span className="info-value">🏆 {match.stats.winner}</span>
            </div>
          )}

          {match.stats?.bestPlayer && (
            <div className="info-row">
              <span className="info-label">Best Player:</span>
              <span className="info-value">⭐ {match.stats.bestPlayer}</span>
            </div>
          )}
        </div>

        {/* Stats Section */}
        {match.stats?.points && match.stats.points.length > 0 && (
          <div className="detail-stats">
            <h4>Point Breakdown</h4>
            <div className="points-display">
              {match.stats.points.map((point, idx) => (
                <span key={idx} className="point">{point}</span>
              ))}
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="detail-footer">
          <p className="updated-time">
            Last updated: {new Date(match.lastUpdated).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              second: '2-digit',
              hour12: true
            })}
          </p>
        </div>

        {/* Close button at bottom */}
        <button className="close-btn-bottom" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
